import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { TESTIMONIALS } from '../../data/content';
import { useLanguage } from '../../i18n/LanguageContext';
export function Testimonials() {
  const {
    lang,
    t
  } = useLanguage();
  return <section className="w-full bg-white py-24 lg:py-32" data-id="element-185" data-mp="2htxquu8b9cm7">
      <div className="mx-auto max-w-container px-6" data-id="element-186" data-mp="3fg4vu58j16z3">
        <SectionHeading eyebrow={t.testimonials.eyebrow} title={t.testimonials.title} description={t.testimonials.description} align="center" data-id="element-187" data-mp="3ffv68ire91tx" />

        <ul className="mt-16 grid gap-6 lg:grid-cols-3" data-id="element-188" data-mp="35gmdft89lt95">
          {TESTIMONIALS.map((item, i) => <Reveal as="li" key={item.name} delay={i * 0.08} data-id="element-189" data-mp="31g2finfvally" data-mpi={i}>
              <figure className="flex h-full flex-col rounded-2xl border border-navy-100 bg-mist p-8 transition-all duration-300 hover:-translate-y-1 hover:border-gold/40 hover:shadow-lift" data-id="element-190" data-mp="1u3jzz71gpjt7">
                <QuoteIcon className="h-7 w-7 text-gold" aria-hidden="true" data-id="element-191" data-mp="2z9zkzlojfqe3" />
                <blockquote className="mt-6 flex-1 font-display text-lg leading-relaxed text-navy" data-id="element-192" data-mp="349kjxw3pjyqt">
                  “{item.copy[lang].quote}”
                </blockquote>
                <figcaption className="mt-8 border-t border-navy-100 pt-5" data-id="element-193" data-mp="2q9jl0m7071dz">
                  <p className="text-sm font-semibold text-navy" data-id="element-194" data-mp="2ua3f1gwa5ovw">{item.name}</p>
                  <p className="mt-1 text-xs text-charcoal-light" data-id="element-195" data-mp="2gjq73eje2a6k">{item.copy[lang].role}</p>
                  <p className="mt-1 text-[11px] uppercase tracking-[0.16em] text-gold-dark" data-id="element-196" data-mp="2lb8bydoj8uwt">
                    {item.copy[lang].location}
                  </p>
                </figcaption>
              </figure>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}